export const getNextSevenDays = () => {
	const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	const next7Days = [];
	for (let i = 0; i < 7; i++) {
		next7Days.push(days[new Date(Date.now() + (i + 1) * 24 * 60 * 60 * 1000).getDay()]);
	}
	return next7Days;
};
